import api from './api';

const PreContractService = {
  getPolicies: async () => {
    const response = await api.get('/pre-contract/policies');
    return response.data;
  },

  // --- NEW METHOD ---
  getPolicy: async (id) => {
    const response = await api.get(`/pre-contract/policies/${id}`);
    return response.data;
  },

  createPolicy: async (data) => {
    const response = await api.post('/pre-contract/policies', data);
    return response.data;
  },

  // --- NEW METHOD ---
  updatePolicy: async (id, data) => {
    const response = await api.put(`/pre-contract/policies/${id}`, data);
    return response.data;
  },

  deletePolicy: async (id) => {
    const response = await api.delete(`/pre-contract/policies/${id}`);
    return response.data;
  },

  getDoAList: async () => {
    const response = await api.get('/pre-contract/doa');
    return response.data;
  },
  getDoA: async (id) => {
    const response = await api.get(`/pre-contract/doa/${id}`);
    return response.data;
  },
  createDoA: async (data) => {
    const response = await api.post('/pre-contract/doa', data);
    return response.data;
  },
  updateDoA: async (id, data) => {
    const response = await api.put(`/pre-contract/doa/${id}`, data);
    return response.data;
  },
  deleteDoA: async (id) => {
    const response = await api.delete(`/pre-contract/doa/${id}`);
    return response.data;
  },

  getDueDiligenceConfig: async () => {
    const response = await api.get('/pre-contract/due-diligence/config');
    return response.data;
  },
  updateDueDiligenceConfig: async (data) => {
    const response = await api.put('/pre-contract/due-diligence/config', data);
    return response.data;
  },

  getComplianceLogs: async () => {
    const response = await api.get('/pre-contract/logs');
    return response.data;
  },
};

export default PreContractService;